import axios from 'axios';

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    checkIP({ commit }) {
      return axios.get('https://www.cloudflare.com/cdn-cgi/trace')
        .then(result => result.data)
        .catch(error => Promise.reject(error));
    },
  },
};
